import React from 'react';
import PropTypes from 'prop-types';
import LineItemShow from './LineItemShow';
import { Draggable } from 'react-beautiful-dnd';
import LineItemEditMobile from './LineItemEditMobile';
import LineItemEditDesktop from './LineItemEditDesktop';
import { Dthc } from '../../../Modules';
import styles from './LineItems.scss';

// eslint-disable-next-line new-cap
const DragHandle = ({ className, dragHandleProps, ...rest }) =>
  <div
    className={[styles.dragHandleContainer, className].join(' ')}
    {...rest}
    {...dragHandleProps}
  >
    <div className={styles.dragHandle} />
  </div>;

DragHandle.propTypes = {
  className: PropTypes.string,
  dragHandleProps: PropTypes.object.isRequired
};

// eslint-disable-next-line new-cap
const LineItemShowSortable = (props) => (
  <div>
    {props.lineItems.map((service, idx) =>
      <Draggable
        draggableId={service.node.id}
        index={idx}
        key={service.node.id || idx}
      >
        {provided =>
          <div>
            <div {...provided.draggableProps} ref={provided.innerRef}>
              <div className={styles.draggableElement}>
                <DragHandle
                  dragHandleProps={provided.dragHandleProps}
                  className={
                    props.draggingIndex !== null &&
                    props.draggingIndex !== idx
                      ? styles.inactiveDragHandle
                      : null
                  }
                />
                <div style={{ flex: 1 }}>
                  <Dthc
                    service={service.node}
                    localService={props.localLineItems[idx].node}
                    onChange={svc => {
                      props.lineItemChangeHandler(svc, idx);
                    }}
                    commitUpdate={props.updateLineItem}
                    desktop={LineItemEditDesktop}
                    mobile={LineItemEditMobile}
                    index={idx}
                    reset={props.resetEditLineItem}
                    delete={props.deleteLineItem}
                  >
                    <LineItemShow service={service.node} />
                  </Dthc>
                </div>
              </div>
            </div>
            {provided.placeholder}
          </div>}
      </Draggable>
    )}
  </div>
);

LineItemShowSortable.propTypes = {
  lineItems: PropTypes.array.isRequired,
  localLineItems: PropTypes.array.isRequired,
  lineItemChangeHandler: PropTypes.func.isRequired,
  updateLineItem: PropTypes.func.isRequired,
  resetEditLineItem: PropTypes.func.isRequired,
  deleteLineItem: PropTypes.func.isRequired,
  draggingIndex: PropTypes.number
};

export default LineItemShowSortable;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/LineItems/LineItemsSortable.js